import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { AutoComplete, Button, Col, DatePicker, Form, Icon, Input, InputNumber, notification, Radio, Row, Spin } from 'antd';
import moment from 'moment';
import _ from 'lodash';

import * as programmeController from '../../../../../../services/api/programme';

import './ProgrammeForm.scss';

const FormItem = Form.Item;
const Option = AutoComplete.Option;
const RadioGroup = Radio.Group;
const TextArea = Input.TextArea;

export class ProgrammeForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            courseCodes: [],
            programmeCategories: [],
            centers: [],
            institutes: [],
            leads: []
        };
    }

    fetchCourseCode() {
        programmeController.getCourseCodes()
            .then((res) => res.json())
            .then((json) => this.setState({ courseCodes: json }))
    }

    fetchProgrammeCategory() {
        programmeController.getProgrammeCategories()
            .then((res) => res.json())
            .then((json) => this.setState({ programmeCategories: json }))
    }

    fetchCenter() {
        programmeController.getCenters()
            .then((res) => res.json())
            .then((json) => this.setState({ centers: json }))
    }

    fetchInstitute() {
        programmeController.getInstitutes()
            .then((res) => res.json())
            .then((json) => this.setState({ institutes: json }))
    }

    handleCourseCodeDelete(courseCodeId, e) {
        e.stopPropagation();

        programmeController.deleteCourseCode(courseCodeId)
            .then((res) => res.json)
            .then((json) => this.fetchCourseCode())
    }

    handleProgrammeCategoryDelete(programmeCategoryId, e) {
        e.stopPropagation();

        programmeController.deleteProgrammeCategory(programmeCategoryId)
            .then((res) => res.json)
            .then((json) => this.fetchProgrammeCategory())
    }

    handleCenterDelete(centerId, e) {
        e.stopPropagation();

        programmeController.deleteProgrammeCategory(centerId)
            .then((res) => res.json)
            .then((json) => this.fetchCenter())
    }

    handleInstituteDelete(instituteId, e) {
        e.stopPropagation();

        programmeController.deleteInstitute(instituteId)
            .then((res) => res.json)
            .then((json) => this.fetchInstitute())
    }

    handleSubmit(e) {
        const { history, match, form } = this.props;
        const { courseCodes, programmeCategories, centers, institutes } = this.state;
        const programmeId = match.params.programmeId;
        const isCreateNewProgramme = match.params.programmeId === undefined;

        e.preventDefault();
        this.setState({ isLoading: true });

        form.validateFields((err, values) => {
            if (!err) {
                const {
                    name,
                    is_active,
                    course_code,
                    programme_category,
                    center,
                    institute,
                    programme_code,
                    tutor,
                    programme_date,
                    application_due_date,
                    head_count,
                    fee,
                    prerequisite,
                    remarks
                } = values;
                const targetCourseCode = _.find(courseCodes, { name: course_code });
                const targetProgrammeCategory = _.find(programmeCategories, { name: programme_category });
                const targetCenter = _.find(centers, { name: center });
                const targetInstitute = _.find(institutes, { name: institute });

                let body = {
                    name,
                    is_active,
                    programme_code,
                    tutor,
                    programme_date,
                    application_due_date,
                    head_count,
                    fee,
                    prerequisite,
                    remarks
                };
                if (_.isEmpty(targetCourseCode))
                    body.course_code = { name: course_code };
                else
                    body.course_code_id = targetCourseCode.id;

                if (_.isEmpty(targetProgrammeCategory))
                    body.programme_category = { name: programme_category };
                else
                    body.programme_category_id = targetProgrammeCategory.id;

                if (_.isEmpty(targetCenter))
                    body.center = { name: center };
                else
                    body.center_id = targetCenter.id;


                if (_.isEmpty(targetInstitute))
                    body.institute = { name: institute };
                else
                    body.institute_id = targetInstitute.id;


                (isCreateNewProgramme ? programmeController.createProgramme(body) : programmeController.updateProgramme(programmeId, body))
                .then((res) => res.json())
                    .then((json) => {
                        this.setState({ isLoading: false });
                        history.push('/dashboard/admin/programme');
                    })
                    .catch((err) => {
                        notification.error({
                            message: 'Unexpected Error',
                            description: 'Please report this issue to engineer.',
                            duration: 0
                        });
                        this.setState({ isLoading: false });
                    })
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    componentDidMount() {
        const { match, form } = this.props;
        const programmeId = match.params.programmeId;
        let promises = [];

        promises.push(this.fetchCourseCode());
        promises.push(this.fetchProgrammeCategory());
        promises.push(this.fetchCenter());
        promises.push(this.fetchInstitute());

        if (programmeId === undefined) {
            form.resetFields();
        } else {
            this.setState({ isLoading: true });
            promises.push(
                programmeController.getProgramme(programmeId)
                .then((res) => res.json())
                .then((json) => {
                    const {
                        name,
                        is_active,
                        course_code,
                        programme_category,
                        center,
                        institute,
                        programme_code,
                        tutor,
                        programme_date,
                        application_due_date,
                        leads,
                        head_count,
                        fee,
                        prerequisite,
                        remarks
                    } = json;
                    form.setFieldsValue({
                        name,
                        is_active,
                        programme_code,
                        tutor,
                        head_count,
                        fee,
                        prerequisite,
                        remarks,
                        course_code: course_code ? course_code.name : '',
                        programme_category: programme_category ? programme_category.name : '',
                        center: center ? center.name : '',
                        institute: institute ? institute.name : '',
                        programme_date: programme_date && moment(programme_date),
                        application_due_date: application_due_date && moment(application_due_date)
                    });
                    this.setState({ leads });
                }));
        }

        Promise.all(promises)
            .then(() => this.setState({ isLoading: false }));
    }

    render() {
        const { history, match, form } = this.props;
        const { isLoading, courseCodes, programmeCategories, centers, institutes, leads } = this.state;
        const { getFieldDecorator } = form;
        const isCreateNewProgramme = match.params.programmeId === undefined;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const courseCodeOptions = _.map(courseCodes, (courseCode) => (
            <Option 
                key={courseCode.name} 
                value={courseCode.name}
            >
                {courseCode.name}
                <div className="option-delete-btn" onClick={(e) => this.handleCourseCodeDelete(courseCode.id, e)}>
                    <Icon type="close" />
                </div>
            </Option>
        ))
        const programmeCategoryOptions = _.map(programmeCategories, (programmeCategory) => (
            <Option 
                key={programmeCategory.name} 
                value={programmeCategory.name}
            >
                {programmeCategory.name}
                <div className="option-delete-btn" onClick={(e) => this.handleProgrammeCategoryDelete(programmeCategory.id, e)}>
                    <Icon type="close" />
                </div>
            </Option>
        ))
        const centerOptions = _.map(centers, (center) => (
            <Option 
                key={center.name} 
                value={center.name}
            >
                {center.name}
                <div className="option-delete-btn" onClick={(e) => this.handleCenterDelete(center.id, e)}>
                    <Icon type="close" />
                </div>
            </Option>
        ))
        const instituteOptions = _.map(institutes, (institute) => (
            <Option 
                key={institute.name} 
                value={institute.name}
            >
                {institute.name}
                <div className="option-delete-btn" onClick={(e) => this.handleInstituteDelete(institute.id, e)}>
                    <Icon type="close" />
                </div>
            </Option>
        ))

        return (
            <Spin spinning={isLoading}>
                <Form className="ProgrammeForm" onSubmit={(e) => this.handleSubmit(e)}>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Name">
                                {
                                    getFieldDecorator('name', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <Input placeholder="Input Programme Name" />
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Active">
                                {
                                    getFieldDecorator('is_active', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                        initialValue: true
                                    })(
                                        <RadioGroup>
                                            <Radio value={true}>Yes</Radio>
                                            <Radio value={false}>No</Radio>
                                        </RadioGroup>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Course Code">
                                {
                                    getFieldDecorator('course_code', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <AutoComplete
                                            placeholder="Input or Select Course Code"
                                            dataSource={courseCodeOptions}
                                            optionLabelProp="value"
                                            filterOption={(inputValue, option) => option.props.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Programme Category">
                                {
                                    getFieldDecorator('programme_category', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <AutoComplete
                                            placeholder="Input or Select Programme Category"
                                            dataSource={programmeCategoryOptions}
                                            optionLabelProp="value"
                                            filterOption={(inputValue, option) => option.props.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Center">
                                {
                                    getFieldDecorator('center', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <AutoComplete
                                            placeholder="Input or Select Center"
                                            dataSource={centerOptions}
                                            optionLabelProp="value"
                                            filterOption={(inputValue, option) => option.props.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Institute">
                                {
                                    getFieldDecorator('institute', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <AutoComplete
                                            placeholder="Input or Select Institute"
                                            dataSource={instituteOptions}
                                            optionLabelProp="value"
                                            filterOption={(inputValue, option) => option.props.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Programme Code">
                                {
                                    getFieldDecorator('programme_code', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <Input placeholder="Input Programme Code"/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Tutor">
                                {
                                    getFieldDecorator('tutor')(
                                        <Input placeholder="Input Tutor Name"/>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Programme Date">
                                {
                                    getFieldDecorator('programme_date', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <DatePicker/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Application Due Date">
                                {
                                    getFieldDecorator('application_due_date', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <DatePicker/>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Available Place(s)">
                                <span>{`${leads.length} / `}</span>
                                {
                                    getFieldDecorator('head_count', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <InputNumber placeholder="Total"/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Fee">
                                {
                                    getFieldDecorator('fee', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <InputNumber
                                            style={{ width: 100 }}
                                            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Pre-requisites">
                                {getFieldDecorator('prerequisite')(
                                    <TextArea autosize={{ minRows: 4, maxRows: 4 }} placeholder="Input Pre-requisites"/>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Remarks">
                                {getFieldDecorator('remarks')(
                                    <TextArea autosize={{ minRows: 4, maxRows: 4 }} placeholder="Input Remarks"/>
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <FormItem>
                            <Button onClick={(e) => history.push('/dashboard/admin/programme')}>Back</Button>
                            {' '}
                            <Button type="primary" htmlType="submit">{isCreateNewProgramme ? 'Create' : 'Update'}</Button>
                        </FormItem>
                    </Row>
                </Form>
            </Spin>
        );
    }
}

const WrappedProgrammeForm = Form.create()(ProgrammeForm);
export default withRouter(WrappedProgrammeForm);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ProgrammeManagementPage/components/ProgrammeForm/ProgrammeForm.js